
<template>
<div :class="'btn-group '+div_class" role="group" style="width: fit-content;">
<button v-if="!onlybuton" type="button" :class="'btn btn-'+size+' btn-'+colortype+'-ikon'"><fa :icon="['fas', ikon]" /></button>
<button v-if="!onlyicon" type="button" :class="'btn btn-'+size+' btn-'+colortype" ><strong><fa v-if="value_icon_l" :icon="['fas', this.value_icon_l]" /> {{value}} <fa v-if="value_icon_r" :icon="['fas', this.value_icon_r]" /></strong></button>
</div>
</template>
<script>
export default {
  name: 'ButtoN',
  props: {
    value: String,
    onlyicon:{ default: false, type: [Boolean,String]},
    onlybuton:{ default: false, type: [Boolean,String]},
    ikon:String,
    buton_value: String,
    colortype:{ default: "info",type: String},
    size:{ default: "sm",type: String},
    input_id: String,
    button_class: String,
    form_icon: String,
    value_icon_l:{ default: false,type: [Boolean,String]},
    value_icon_r:{ default: false,type: [Boolean,String]},
    div_class:String
  }
}
</script>
<style>
.btn-info-ikon{
  background-color: #0595bd !important;
}
.btn-success-ikon{
  background-color: #076b19 !important;
  color:white;
}

.btn-primary-ikon{
  background-color: #0b54c0 !important;
  color:white;
}

.btn-secondary-ikon{
  background-color: #565f68 !important;
  color:white;
}
.btn-danger-ikon{
  background-color: #bc212f !important;
  color:white;
}

.btn-warning-ikon{
  background-color: #cda52d !important;
  color:black;
}
.btn-light-ikon{
  background-color: #f0f0f1 !important;
}
.btn-disabled{
  background-color: #bbbbbb !important;
  color:white;
}
.btn-disabled-ikon{
  background-color: #bbbbbb !important;
  color:white;
}
.btn-dark-ikon{
  background-color: #0f1011 !important;
  color:white;
}

.btn-sm{
  font-size: 0.68rem !important;
}
</style>